import { render, staticRenderFns } from "./modalRefer.vue?vue&type=template&id=31ae2cf9"
import script from "./modalRefer.vue?vue&type=script&lang=js"
export * from "./modalRefer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports